import store from '@/store';

class _NetworkServices {

    // il plugin non emette eventi mentre l'app è in background: richiamare a deviceready/resume
    refresh() {
        store.state.isOnline = this.isCurrentlyOnline();
    }

    // chiamato solo in contesto Cordova (onDeviceReady/onResume): fuori da Cordova l'offline non ci interessa
    private isCurrentlyOnline(): boolean {
        let connection = (<any>navigator).connection;
        if (!connection)
            return true;

        // su iOS il tipo reale richiede ~1s per stabilizzarsi: fino ad allora resta UNKNOWN, restiamo ottimisti
        if (typeof Connection != 'undefined' && (connection.type == Connection.NONE || connection.type == Connection.UNKNOWN))
            return false;

        return true;
    }
}

export let NetworkServices = new _NetworkServices();
